/* eslint-disable @typescript-eslint/no-explicit-any */
import { AuthService } from '../auth/AuthService';
import { ApiBack } from '../axios-config';

export interface ISituacaoEmergencia {
    uuid?: string,
    data_atualizacao?: string,
    // nivel_emergencia?: string,
    nive_emergencia?: string,
    id_pae?: string
}

export interface IRupturaHipotetica {
    uuid?: string;
    fluxo_newtoniano?: string;
    reologia?: string;
    caracterizacao_reologica?: string;
    cenarios_simulados?: string;
    falha_cenario_critico?: string;
    volume_mobilizado_m3?: string;
    volume_mobilizado?: string;
    tr_jusante?: string;
    tr_critico?: string;
    parada_mancha?: string;
    definicao_zas?: string;
    id_pae?: string;
}

export interface INiveisEmergencia {
    uuid?: string,
    definicao?: string,
    nivel?: string,
    id_pae?: string,
}

export interface IPae {
    uuid?: string,
    id_barragem?: string,
    empresa_executora?: string,
    responsavel_tecnico?: string,
    art?: string,
    orgao_fiscalizador?: string,
    data_emissao: string,
    situacaoEmergencia?: ISituacaoEmergencia,
    estudoRuptura?: IRupturaHipotetica,
    niveisEmergencia?: INiveisEmergencia[],
}

export interface IListPae {
    uuid: string,
    id_barragem: string,
    empresa_executora?: string,
    responsavel_tecnico?: string,
    art?: string,
    orgao_fiscalizador?: string,
    data_emissao: string,
}

const create = async (data: IPae): Promise<string | Error> => {

    await AuthService.verify();

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.post('/pae', data, {
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data) {
            return response.data;
        }

        return new Error('Erro ao criar novo PAE');
    } catch (error: any){
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao criar novo usuário');
        }
    }
};

const upgrade = async (data: IPae, uuid: string): Promise<string | Error> => {

    await AuthService.verify();

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.put(`/pae?uuid=${uuid}`, data, {
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data) {
            return response.data;
        }

        return new Error('Erro ao atualizar novo PAE');
    } catch (error: any){
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao atualizar novo usuário');
        }
    }
};

const get = async (uuid: string): Promise<IPae | Error> => {

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.get(`/pae?uuid=${uuid}`, {
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data) {
            return response.data;
        }

        return new Error('Erro ao buscar PAE');
    } catch (error: any){
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao buscar PAE');
        }
    }

};

const list = async (uuid: string): Promise<IListPae[] | Error> => {

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.get(`/paes?uuid=${uuid}`, {
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data) {
            return response.data;
        }

        return new Error('Erro ao listar PAEs');
    } catch (error: any){
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao listar PAEs');
        }
    }
};

const delet = async (uuid: string): Promise<string | Error> => {

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.delete(`/pae?uuid=${uuid}`, {
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data) {
            return response.data;
        }

        return new Error('Erro ao listar PAEs');
    } catch (error: any){
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao listar PAEs');
        }
    }
};

export interface ILastPaeItem {
    rise?: string | null;
    risr?: string | null;
    rpsb?: string | null;
    pae?: string | null;
    aco?: string | null;
    uuid: string | null;
}

export type ILastPaes = ILastPaeItem[];

const lastPaes =  async (uuid_dam: string): Promise<ILastPaes | Error> => {

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.get(`/ultimos_relatorios?uuid=${uuid_dam}`, {
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data) {
            return response.data;
        }

        return new Error('Erro ao buscar ultimos relatorios');
    } catch (error: any){
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao buscar ultimos relatorios');
        }
    }
};

export const PaeServices = {
    create,
    get,
    list,
    delet,
    upgrade,
    lastPaes
};